function testUserAgent(userAgent: RegExp) {
  const regex = new RegExp(userAgent);
  return regex.test(window?.navigator.userAgent ?? "");
}

export function checkInAppPage() {
  // IOS WebView detection (custom user agent iosApp)
  const isIOSWebView = testUserAgent(/iosApp/i);

  // Android WebView detection (custom user agent androidApp)
  const isAndroidWebView =
    testUserAgent(/android/i) && testUserAgent(/androidApp/);

  return isIOSWebView || isAndroidWebView;
}
